var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrowave = function SvgMicrowave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#microwave_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 19,
    x: 19.5,
    y: 2.5,
    stroke: "currentColor",
    rx: 1.5,
    transform: "rotate(90 19.5 2.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.5,
    height: 2.5,
    x: 15,
    y: 10.5,
    stroke: "currentColor",
    rx: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    x: 15.25,
    y: 7,
    fill: "currentColor",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    x: 15.25,
    y: 5,
    fill: "currentColor",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M13 5.5v7a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "microwave_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgMicrowave;